import React, { useEffect, useRef, useState } from 'react';
import GalleryItem from './GalleryItem';

const PAGE_SIZE = 60; // tiles rendered per batch; more are added as the user nears the end

export const Gallery = ({
  photos = { image: [], gif: [], video: [] },
  matches,
  type = 'image',
  onPhotoClick,
}) => {
  const items = (matches ? matches[type] : photos[type]) || [];
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
  const sentinelRef = useRef(null);
  const hasMore = visibleCount < items.length;

  // The parent remounts this component per tab; jump (not smooth-scroll) to the top so the
  // sentinel is not swept through view and every batch loaded at once
  useEffect(() => {
    // Browsers without CSS scroll-behavior (older Safari) always jump and ignore the options form
    if ('scrollBehavior' in document.documentElement.style) window.scrollTo({ top: 0, behavior: 'instant' });
    else window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!hasMore || !sentinel) return undefined;

    if (!('IntersectionObserver' in window)) {
      setVisibleCount(items.length);
      return undefined;
    }

    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) setVisibleCount(count => count + PAGE_SIZE);
      },
      { rootMargin: '800px 0px' }
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [hasMore, items.length, visibleCount]);

  return (
    <React.Fragment>
      <div className="gallery-grid">
        {items.slice(0, visibleCount).map(photo => (
          <GalleryItem key={photo.id} photo={photo} onPhotoClick={onPhotoClick} />
        ))}
      </div>
      {hasMore && <div ref={sentinelRef} className="gallery-sentinel" aria-hidden="true" />}
    </React.Fragment>
  );
};
